import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './header-links.css'

const HeaderLinks = (props) => {
  const [isContactVisible, setIsContactVisible] = useState(false)
  return (
    <nav className={`header-links-nav ${props.rootClassName} `}>
      <Link to="/" className="header-links-navlink">
        Início
      </Link>
      <a href="/#processo" className="header-links-link2">
        <span>Processo</span>
        <br></br>
      </a>
      <a href="#falecomigo" className="header-links-link3">
        Entrar em Contato
      </a>
    </nav>
  )
}

HeaderLinks.defaultProps = {
  rootClassName: '',
}

HeaderLinks.propTypes = {
  rootClassName: PropTypes.string,
}

export default HeaderLinks
